import axios from 'axios';

export const INITIALIZATION_GET_PROJECT_BRANCH 			= '[INITIALIZATION APP] GET PROJECT BRANCH';
export const INITIALIZATION_GET_PROJECT_TYPE   			= '[INITIALIZATION APP] GET PROJECT TYPE';
export const INITIALIZATION_GET_GROUP_TYPE 				= '[INITIALIZATION APP] GET GROUP TYPE';
export const INITIALIZATION_GET_USER_POSITION   		= '[INITIALIZATION APP] GET USER POSITION';

export const INITIALIZATION_CREATE_PROJECT_BRANCH		= '[INITIALIZATION APP] CREATE PROJECT BRANCH';
export const INITIALIZATION_CREATE_PROJECT_TYPE			= '[INITIALIZATION APP] CREATE PROJECT TYPE';
export const INITIALIZATION_CREATE_GROUP_TYPE			= '[INITIALIZATION APP] CREATE GROUP TYPE';
export const INITIALIZATION_CREATE_USER_POSITION		= '[INITIALIZATION APP] CREATE USER POSITION';

export const INITIALIZATION_UPDATE_PROJECT_BRANCH		= '[INITIALIZATION APP] UPDATE PROJECT BRANCH';
export const INITIALIZATION_UPDATE_PROJECT_TYPE			= '[INITIALIZATION APP] UPDATE PROJECT TYPE';
export const INITIALIZATION_UPDATE_GROUP_TYPE			= '[INITIALIZATION APP] UPDATE GROUP TYPE'; 
export const INITIALIZATION_UPDATE_USER_POSITION		= '[INITIALIZATION APP] UPDATE USER POSITION'; 

export const INITIALIZATION_DELETE_PROJECT_BRANCH       = '[INITIALIZATION APP] DELETE AND RECOVER PROJECT BRANCH';
export const INITIALIZATION_DELETE_PROJECT_TYPE         = '[INITIALIZATION APP] DELETE AND RECOVER PROJECT TYPE';
export const INITIALIZATION_DELETE_GROUP_TYPE         = '[INITIALIZATION APP] DELETE AND RECOVER GROUP TYPE';
export const INITIALIZATION_DELETE_USER_POSITION         = '[INITIALIZATION APP] DELETE AND RECOVER USER POSITION';

export const SELECTED_TAB   							= '[INITIALIZATION APP] GET SELECTED TAB';
export const HANDLE_EDIT_VALUE      					= '[INITIALIZATION APP] HANDLE EDIT VALUES';
export const HANDLE_MODAL＿RECOVER						= '[INITIALIZATION APP] HANDLE MODAL RECOVER';
export const HANDLE_MODAL＿DELETE     					= '[INITIALIZATION APP] HANDLE MODAL DELETE';
export const MEMBER_SEARCH_TEXT		    				= '[INITIALIZATION APP] PROJECT SEARCH TEXT';
export const SET_FILTER_CHECKBOX 						= '[INITIALIZATION APP] FILTER CHECKBOX';
export const INITIALIZATION_PAGE_CLICK_FLAG             = '[INITIALIZATION APP] FLAG CLICK';
export const HANDLING_RESPONSE_INITIALIZATION_PAGE      = '[INITIALIZATION APP] HANDLING RESPONSE MEMBERS PAGE';

//::Get Project Branch
export function initialization_getProjectBranch(data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		const companyID = data
		const request = axios.get(process.env.REACT_APP_SERVER + '/api/common/common-type-private?companyID=' + companyID + '&type=ProjectBranch' , headersToken)
		
		return request.then(response => {
			//console.log('Load Initialization - Project Branch Succesfully', response.data);
			return dispatch({
				type: INITIALIZATION_GET_PROJECT_BRANCH,
				payload: response.data,
			});
		}).catch( error =>{
			//console.log('Could not load data from Initialization - Project Branch Error', error);
		})
	};	
}

//::Get Project Type
export function initialization_getProjectType(data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		const companyID = data
		const request = axios.get(process.env.REACT_APP_SERVER + '/api/common/common-type-private?companyID=' + companyID + '&type=ProjectType' , headersToken)
		
		return request.then(response => {
			//console.log('Load Initialization - Project Type Succesfully', response.data);
			return dispatch({
				type: INITIALIZATION_GET_PROJECT_TYPE,
				payload: response.data,
			});
		}).catch( error =>{
			//console.log('Could not load data from Initialization - Project Type Error', error);
		})
	};	
}

//::Get Group Type
export function initialization_getGroupType(data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		const companyID = data
		const request = axios.get(process.env.REACT_APP_SERVER + '/api/common/common-type-private?companyID=' + companyID + '&type=GroupType' , headersToken)
		
		return request.then(response => {
			//console.log('Load Initialization - Group Type Succesfully', response.data);
			return dispatch({
				type: INITIALIZATION_GET_GROUP_TYPE,
				payload: response.data,
			});
		}).catch( error =>{
			//console.log('Could not load data from Initialization - Group Type Error', error);
		})
	};	
}

//::Get User Position
export function initialization_getUserPosition(data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		const companyID = data
		const request = axios.get(process.env.REACT_APP_SERVER + '/api/common/common-type-private?companyID=' + companyID + '&type=UserPosition' , headersToken)
		
		return request.then(response => {
			//console.log('Load Initialization - User Position Succesfully', response.data);
			return dispatch({
				type: INITIALIZATION_GET_USER_POSITION,
				payload: response.data,
			});
		}).catch( error =>{
			//console.log('Could not load data from Initialization - User Position Error', error);
		})
	};	
}

//::Create Project Branch
export function initialization_createProjectBranch(companyIDdata,data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		//console.log('FORM DATA HERE', data)
		const companyID = companyIDdata
		const request = axios.post(process.env.REACT_APP_SERVER + '/api/common/common-type-private', data, headersToken)
		
		return request.then(response => {
			//console.log('Create Initialization - Project Branch Succesfully', response.data);
			dispatch(initialization_getProjectBranch(companyID));
			dispatch(initializationPageClickFlag('Create'));
			//dispatch(handlingResponseInitializationPage(true));
			return dispatch({
				type: INITIALIZATION_CREATE_PROJECT_BRANCH,
				payload: response.data,
			});
		}).catch( error =>{
			//console.log('Could not Create data from Initialization - Project Branch Error', error.response);
			dispatch(initializationPageClickFlag('Error'));
			//dispatch(handlingResponseInitializationPage(false));
		})
	};	
}

//::Create Project Type
export function initialization_createProjectType(companyIDdata,data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		//console.log('FORM DATA HERE', data)
		const companyID = companyIDdata
		const request = axios.post(process.env.REACT_APP_SERVER + '/api/common/common-type-private', data, headersToken)
		
		return request.then(response => {
			//console.log('Create Initialization - Project Type Succesfully', response.data);
			dispatch(initialization_getProjectType(companyID));
			dispatch(initializationPageClickFlag('Create'));
			//dispatch(handlingResponseInitializationPage(true));
			return dispatch({
				type: INITIALIZATION_CREATE_PROJECT_TYPE,
				payload: response.data,
			});
		}).catch( error =>{
			//console.log('Could not Create data from Initialization - Project Type Error', error.response);
			dispatch(initializationPageClickFlag('Error'));
			//dispatch(handlingResponseInitializationPage(false));
		})
	};	
}

//:: Create Group Type
export function initialization_createGroupType(companyIDdata, data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		//console.log('FORM DATA HERE', data)
		const companyID = companyIDdata
		const request = axios.post(process.env.REACT_APP_SERVER + '/api/common/common-type-private' , data, headersToken)
		
		return request.then(response => {
			//console.log('Create Initialization - Group Type Succesfully', response.data);
			dispatch(initialization_getGroupType(companyID));
			dispatch(initializationPageClickFlag('Create'));
			//dispatch(handlingResponseInitializationPage(true));
			return dispatch({
				type: INITIALIZATION_CREATE_GROUP_TYPE,
				payload: response.data,
			});
		}).catch( error =>{
			//console.log('Could not create data from Initialization - Group Type Error', error.response);
			dispatch(initializationPageClickFlag('Error'));
			//dispatch(handlingResponseInitializationPage(false));
		})
	};	
}

//:: Create User Position
export function initialization_createUserPosition(companyIDdata, data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		//console.log('FORM DATA HERE', data)
		const companyID = companyIDdata
		const request = axios.post(process.env.REACT_APP_SERVER + '/api/common/common-type-private' , data, headersToken)
		
		return request.then(response => {
			//console.log('Create Initialization - User Position Succesfully', response.data);
			dispatch(initialization_getUserPosition(companyID));
			dispatch(initializationPageClickFlag('Create'));
			//dispatch(handlingResponseInitializationPage(true));
			return dispatch({
				type: INITIALIZATION_CREATE_USER_POSITION,
				payload: response.data,
			});
		}).catch( error =>{
			//console.log('Could not create data from Initialization - User Position Error', error.response);
			dispatch(initializationPageClickFlag('Error'));
			//dispatch(handlingResponseInitializationPage(false));
		})
	};	
}


//::Update Project Branch
export function initialization_updateProjectBranch(companyIDdata,data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		//console.log('FORM DATA HERE', data)
		const companyID = companyIDdata
		const request = axios.put(process.env.REACT_APP_SERVER + '/api/common/common-type-private', data, headersToken)
		
		return request.then(response => {
			//console.log('Update Initialization - Project Branch Succesfully', response.data);
			dispatch(initialization_getProjectBranch(companyID));
			dispatch(initializationPageClickFlag('Update'));
			//dispatch(handlingResponseInitializationPage(true));
			return dispatch({
				type: INITIALIZATION_UPDATE_PROJECT_BRANCH,
				payload: response.data,
			});
		}).catch( error =>{
			//console.log('Could not Update data from Initialization - Project Branch Error', error.response);
			dispatch(initializationPageClickFlag('Error'));
			//dispatch(handlingResponseInitializationPage(false));
		})
	};	
}

//::Update Project Type
export function initialization_updateProjectType(companyIDdata,data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		//console.log('FORM DATA HERE', data)
		const companyID = companyIDdata;
		const request = axios.put(process.env.REACT_APP_SERVER + '/api/common/common-type-private', data, headersToken);
		
		return request.then(response => {
			//console.log('Update Initialization - Project Type Succesfully', response.data);
			dispatch(initialization_getProjectType(companyID));
			dispatch(initializationPageClickFlag('Update'));
			//dispatch(handlingResponseInitializationPage(true));
			return dispatch({
				type: INITIALIZATION_UPDATE_PROJECT_TYPE,
				payload: response.data,
			});
		}).catch( error =>{
			//console.log('Could not Update data from Initialization - Project Type Error', error.response);
			dispatch(initializationPageClickFlag('Error'));
			//dispatch(handlingResponseInitializationPage(false));
		})
	};	
}

//:: Update Group Type
export function initialization_updateGroupType(companyIDdata, data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		//console.log('FORM DATA HERE', data)
		const companyID = companyIDdata;
		const request = axios.put(process.env.REACT_APP_SERVER + '/api/common/common-type-private' , data, headersToken);
		
		return request.then(response => {
			//console.log('Update Initialization - Group Type Succesfully', response.data);
			dispatch(initialization_getGroupType(companyID));
			dispatch(initializationPageClickFlag('Update'));
			//dispatch(handlingResponseInitializationPage(true));
			return dispatch({
				type: INITIALIZATION_UPDATE_GROUP_TYPE,
				payload: response.data,
			});
		}).catch( error =>{
			//console.log('Could not Update data from Initialization - Group Type Error', error.response);
			dispatch(initializationPageClickFlag('Error'));
			//dispatch(handlingResponseInitializationPage(false));
		})
	};	
}

//:: Update User Position
export function initialization_updateUserPosition(companyIDdata, data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		//console.log('FORM DATA HERE', data)
		const companyID = companyIDdata;
		const request = axios.put(process.env.REACT_APP_SERVER + '/api/common/common-type-private' , data, headersToken);
		
		return request.then(response => {
			//console.log('Update Initialization - User Position Succesfully', response.data);
			dispatch(initialization_getUserPosition(companyID));
			dispatch(initializationPageClickFlag('Update'));
			//dispatch(handlingResponseInitializationPage(true));
			return dispatch({
				type: INITIALIZATION_UPDATE_USER_POSITION,
				payload: response.data,
			});
		}).catch( error =>{
			//console.log('Could not Update data from Initialization - User Position Error', error.response);
			dispatch(initializationPageClickFlag('Error'));
			//dispatch(handlingResponseInitializationPage(false));
		})
	};	
}










//::Delete/Recover Project Branch
export function initialization_deleteProjectBranch(data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};
		const newData = {
			...data,
			companyID : data.companyId,
			type: 'ProjectBranch',
			is_deleted : !data.is_deleted,
		}
		//console.log('FORM DATA HERE', newData)
		const request = axios.patch(process.env.REACT_APP_SERVER + '/api/common/common-type-private', newData, headersToken)
		
		return request.then(response => {
			//console.log('Delete Initialization - Project Branch Succesfully', response.data);
			dispatch(initialization_getProjectBranch(newData.companyID));
			return dispatch({
				type: INITIALIZATION_DELETE_PROJECT_BRANCH,
				payload: response.data,
			});
		}).catch( error =>{
			//console.log('Could not Delete data from Initialization - Project Branch Error', error.response);
		})
	};	
}

//::Delete/Recover Project Type
export function initialization_deleteProjectType(data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};
		const newData = {
			...data,
			companyID : data.companyId,
			type: 'ProjectType',
			is_deleted : !data.is_deleted,
		}
		//console.log('FORM DATA HERE', newData)
		const request = axios.patch(process.env.REACT_APP_SERVER + '/api/common/common-type-private', newData, headersToken)
		
		return request.then(response => {
			//console.log('Delete Initialization - Project Type Succesfully', response.data);
			dispatch(initialization_getProjectType(newData.companyID));
			return dispatch({
				type: INITIALIZATION_DELETE_PROJECT_TYPE,
				payload: response.data,
			});
		}).catch( error =>{
			//console.log('Could not Delete data from Initialization - Project Type Error', error.response);
		})
	};	
}

//::Delete/Recover Group Type
export function initialization_deleteGroupType(data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};
		const newData = {
			...data,
			companyID : data.companyId,
			type: 'GroupType',
			is_deleted : !data.is_deleted,
		}
		//console.log('FORM DATA HERE', newData)
		const request = axios.patch(process.env.REACT_APP_SERVER + '/api/common/common-type-private', newData, headersToken)
		
		return request.then(response => {
			//console.log('Delete Initialization - Group Type Succesfully', response.data);
			dispatch(initialization_getGroupType(newData.companyID));
			return dispatch({
				type: INITIALIZATION_DELETE_GROUP_TYPE,
				payload: response.data,
			});
		}).catch( error =>{
			//console.log('Could not Delete data from Initialization - Group Type Error', error.response);
		})
	};	
}

//::Delete/Recover User Position
export function initialization_deleteUserPosition(data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};
		const newData = {
			...data,
			companyID : data.companyId,
			type: 'UserPosition',
			is_deleted : !data.is_deleted,
		}
		//console.log('FORM DATA HERE', newData)
		const request = axios.patch(process.env.REACT_APP_SERVER + '/api/common/common-type-private', newData, headersToken)
		
		return request.then(response => {
			//console.log('Delete Initialization - User Position Succesfully', response.data);
			dispatch(initialization_getUserPosition(newData.companyID));
			return dispatch({
				type: INITIALIZATION_DELETE_USER_POSITION,
				payload: response.data,
			});
		}).catch( error =>{
			//console.log('Could not Delete data from Initialization - User Position Error', error.response);
		})
	};	
}


//Click Flag Initialization Page
export function initializationPageClickFlag(data){
	return{
		type: INITIALIZATION_PAGE_CLICK_FLAG,
		payload: data
	}
} 

//::Handling Response 
export function handlingResponseInitializationPage(data){
	return{
		type: HANDLING_RESPONSE_INITIALIZATION_PAGE,
		payload: data
	}
}



export function selectedTab(tab) {
	return {
		type: SELECTED_TAB,
		tab:tab
	};
}

export function handleEditValue(data){
	return{
		type: HANDLE_EDIT_VALUE,
		payload:data,
	}
}

export function searchMember(event) {
	return {
		type: MEMBER_SEARCH_TEXT,
		searchMember: event.target.value
	};
}

export function searchFilterCheckbox(data) {
	return {
		type: SET_FILTER_CHECKBOX,
		payload: data
	};
}

export function handleModalRecover(data){
	return{
		type: HANDLE_MODAL＿RECOVER,
		payload:data,
	}
}

export function handleModalDelete(data){
	return{
		type: HANDLE_MODAL＿DELETE,
		payload:data,
	}
}

